import React from 'react';
import './LogosPartners.scss';
import './LogosPartners-media.scss';
import CardLogo from '../CardLogo/CardLogo';
import { Props } from './interfaces';

const LogosPartners = ({ list }: Props) => {
  return (
    <div className="logos-partners">
      {list.map((item, i) => (
        <CardLogo card={item} key={i} />
      ))}
    </div>
  );
};

export default LogosPartners;
